export const TRAVEL_PREMIUMS = "TRAVEL_PREMIUMS";
export const TRAVEL_PREMIUMS_SUCCESS = "TRAVEL_PREMIUMS_SUCCESS";
export const TRAVEL_PREMIUMS_ERROR = "TRAVEL_PREMIUMS_ERROR";
export const TRAVEL_PREMIUMS_CLEAR_DATA = "TRAVEL_PREMIUMS_CLEAR_DATA";
